import merge from 'lodash/merge';
import { Vehicle } from 'types/generatedSchemaTypes';
import { create } from 'zustand';

type VehicleStore = {
  vehicleData: Vehicle;
  unsavedChanges: boolean;
  vehicleSaved: boolean;
  isDiscarded: boolean;
  isDeleted: boolean;
};

type VehicleStoreActions = {
  setVehicleData: (values: Partial<Vehicle>) => void;
  setUnsavedChanges: (hasChanges: boolean) => void;
  setVehicleSaved: (isSaved: boolean) => void;
  setIsDiscarded: (isDiscarded: boolean) => void;
  setIsDeleted: (isDeleted: boolean) => void;
  resetVehicleStore: () => void;
};

const initialVehicleData: Vehicle = {
  licensePlate: {
    plateText: '',
    countryCode: undefined,
  },
  name: '',
  appSettings: {
    color: '',
    icon: '',
    type: 'REGULAR',
    evPlugType: undefined,
  },
  cameraRecognition: {
    allowed: false,
    enabled: false,
    countryCodes: [],
  },
};

export const useVehicleStore = create<VehicleStore & VehicleStoreActions>()(
  (set) => ({
    vehicleData: initialVehicleData,
    unsavedChanges: false,
    vehicleSaved: false,
    isDiscarded: false,
    isDeleted: false,

    setVehicleData: (values: Partial<Vehicle>) => {
      // With this merge logic, we can call this function with a full vehicle data -> initial edit view, set the vehicle data
      // or we can just pass the parts we want to update
      // for example:
      // setVehicleData({ cameraRecognition: { enabled: true } })
      set((state) => ({
        vehicleData: merge({}, state.vehicleData, values),
      }));
    },

    setUnsavedChanges: (hasChanges: boolean) => {
      set(() => ({ unsavedChanges: hasChanges }));
    },
    setVehicleSaved: (isSaved: boolean) => {
      set(() => ({ vehicleSaved: isSaved }));
    },
    setIsDiscarded: (isDiscarded: boolean) => {
      set(() => ({ isDiscarded }));
    },
    setIsDeleted: (isDeleted: boolean) => {
      set(() => ({ isDeleted }));
    },
    resetVehicleStore: () => {
      set(() => ({
        vehicleData: initialVehicleData,
        unsavedChanges: false,
        vehicleSaved: false,
        isDiscarded: false,
        isDeleted: false,
      }));
    },
  })
);
